import { pushToDataLayer, DataLayerEvent, UserLogoutTrigger } from '@paybis/frontend-common-lib/src/services/gtm';

const corporateAccordions = [];

document.addEventListener('click', handleClickOutside);
document.addEventListener('DOMContentLoaded', function () {
  addClickHandler('.nav-accordion__toggle', navAccordionToggle);

  [
    ...document.querySelectorAll(
      '.nav-member-mob__menu-section--collapsible .nav-member-mob__menu-section-title',
    ),
  ].forEach(function (el) {
    el.addEventListener('click', function () {
      el.classList.toggle('is-open');
    });
  });

  handleLogoutClick();
});

function handleLogoutClick() {
  document.querySelectorAll(`form[action*="/logout"]`).forEach(logoutForm => {
    const logoutButton = logoutForm.querySelector('button[type="submit"]');
    if (!logoutButton) {
      return;
    }
    logoutButton.addEventListener('click', () => {
      pushToDataLayer({
        event: DataLayerEvent.LOGOUT_SUCCESS,
        reason: UserLogoutTrigger.CLICK,
      });
    });
  });
}

function handleClickOutside(e) {
  if (!corporateAccordions.length) {
    return;
  }

  corporateAccordions.forEach(accordion => {
    if (!accordion.parentNode.contains(e.target)) {
      accordion.classList.remove('is-open');
    }
  });
}

function checkCorporateAccordions(toggleElement) {
  return corporateAccordions.findIndex(accordion => accordion === toggleElement) !== -1;
}

function closeCorporateAccordionsExcept(toggleElement) {
  corporateAccordions.forEach(accordion => {
    if (accordion === toggleElement) {
      return;
    }

    accordion.classList.remove('is-open');
  });
}

function navAccordionToggle({ currentTarget }) {
  if (currentTarget.classList.contains('nav-accordion__toggle--corporate')) {
    closeCorporateAccordionsExcept(currentTarget);
    if (!checkCorporateAccordions(currentTarget)) {
      corporateAccordions.push(currentTarget);
    }
  }

  currentTarget.classList.toggle('is-open');
}

function addClickHandler(cssClassSelector, handlerMethod) {
  const elementList = document.querySelectorAll(cssClassSelector);
  
  elementList.forEach((element) => {
    element.addEventListener('click', handlerMethod);
  });
}
